module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAAAXNSR0IArs4c6QAAAVtJREFUKBWNkq9Pw1AQx/deSwiKhASBQdBfAodBMIcCFEEgmRmOBI9g+wsQOFCVJKAgYFgwJGBJMG1XVYGeqVnbx/ead0vXdYSXNHfvvp/cu++lrTAML/ANoyjaav1xJLQzpZRVFMVTHMfr81gCb7S4luf5M+DlJlg6jnMJ4Y5EdN7MsuwBcaEOSyGEklKeQHjX4i7mva2DggtJkqykafqBu6trfc/zeqxPQCrA/QbCJ55e1UAHsE/5FEgFwNsIb4CXEMemae5ZljWYAQkOguAQs98DJg8jeGg3ggTD0Dl2e0U54C/a43+OauxYfxodd2bAeWamntbredSOaaQuOaZkAtLCAbzgK3cIpz3eIYHl03C4CIevuLfLohC+67odyvlIdBCAfBRKCHGAH6XLAEcT3fq4HFMB7r4NwzhCHDPAkWY81ZcfzLWP4UcsViOB1+gQAzqwbTupitX8F9D6lD2KWOfpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/next_chapter.png
// module id = Tp2Y
// module chunks = 0